import type { ExperimentNameUnion, ExperimentVersions } from '../types'
import { useCoreConfig } from '#imports'

/**
 * Looks up the version mapping for an experiment from the runtime config.
 *
 * @param experimentName - The experiment to look up
 * @returns The version mapping if found, or `undefined` if the experiment is not active
 *
 * @example
 * const versions = useExperimentVersions(ExperimentName.SIGNUP)
 * // versions?.a === '5_8_26'
 * // versions?.b === '5_9_26'
 */
export const useExperimentVersions = (experimentName: ExperimentNameUnion): ExperimentVersions | undefined => {
    const { experiments } = useCoreConfig()

    if (!experiments?.length) return

    return experiments?.find(experiment => experiment.name === experimentName)?.versions
}
